import React from "react";
 
const Card = ({ imageUrl, title, text }) => {
  return (
    <div className="createCard">
      <img
        className="card-img-top"
        src={imageUrl}
        alt="Card image cap"
        aria-hidden
        style={{ borderTopLeftRadius: '11px', borderTopRightRadius: '11px' }}
        />
      <div className="card-body" style={{borderBottomLeftRadius: '11px', borderBottomRightRadius: '11px' }}>
        <h5 className="card-title text-center" style={{ fontWeight: "bold" }}>
          {title}
        </h5>
        <p className="card-text">{text}</p>
      </div>
    </div>
  );
};
 
export default Card;
// >>>>>>>> 7f05519754ed24ca860c867e21d6986a063de8a3:src/screens/HomeScreen/Card.jsx
 